module.exports = __webpack_public_path__ + "static/media/ChronicleSSm-Book_Web.45dbcba0.woff2";